import {inject, Pipe, PipeTransform} from '@angular/core';
import { AdminService } from '../admin/services/admin.service';

@Pipe({
    name: 'priority',
    standalone: false
})
export class PriorityPipe implements PipeTransform {

  private adminService = inject(AdminService);

  transform(value: any, type: any): any {
    if(type==='model'){
      switch(value.model_class){
        case 'Event':
          return value.content;

        default:
          return this.adminService.getText(value.model_class, 'lowercase');
      }
    }else if(type==='action'){
      switch(value){
        case 'added-to-document':
          return 'Has sido añadido a un/a';
        case 'answer':
          return 'Cliente respondió una'
        case 'pricing_answered':
        return 'Proveedor respondió una';
        case 'answered_buy_order':
          return 'Proveedor confirmó una';
        case 'assigned':
          return 'Te han asignado un nuevo';
        case 'assignation_required':
          return 'Un trabajo necesita un';
        case 'completed_request':
          return 'Actualizado estado de';
        case 'event':
          return 'Pronto: ';
        case 'mentioned':
          return 'Te mencionaron en un';
        case 'request':
          return 'Requerimiento de';
        case 'recall':
          return 'Alerta de ';
        case 'revision_required':
          return 'Requerida revisión de un';  
        default:
          return value;
      }
    }else if(type==='icon'){
      switch(value){
        case 'WorkAssignation':
          return 'fa-wrench';
        case 'OrderComment':
          return 'fa-comment';
        case 'WorkRequest':
          return 'fa-bullhorn';
        case 'Event':
          return 'fa-clock-o';
        case 'InventoryAction::Pricing':
          return 'fa-usd';
        case 'InventoryAction::BuyOrder':
          return 'fa-list';
        default:
          return 'fa-bullhorn';
      }
    }
  }

}
